import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';
import isLogScaleAllowed from '../../util/logScale';

function getDataPanelType(data) {
  switch (data.type) {
    case 'market':
    case 'econ':
      return `${data.type}data`;
    default:
      return 'data';
  }
}

function fetchChartData(state, action) {
  if (!action.data) {
    return state;
  }

  if (action.data.status === 'success') {
    const { data } = action.data.body.chart;

    return {
      sheetsUrl: data.sheetsUrl ?? null,
      sheetsLastUpdated: data.sheetsLastUpdated ?? null,
      sheetsError: data.sheetsError ?? null,
      sheetName: data.sheetName || { id: '', name: '' },
      sheetNames: data.sheetNames || [],
      firstCell: data.firstCell || '',
      lastCell: data.lastCell || '',
      dataPanelType: data.dataPanelType || getDataPanelType(data),
      firstRowAsNames: data.firstRowAsNames,
      firstColumnAsCategories: data.firstColumnAsCategories,
      removeOverlappingCategories: data.removeOverlappingCategories,
      allowCategoriesLinebreak: data.allowCategoriesLinebreak,
      categoriesAreDates: data.categoriesAreDates,
      categoriesAreMonthly: data.categoriesAreMonthly,
      fiscalYears: data.fiscalYears,
      irregularDates: data.irregularDates,
      reverseDateMonth: data.reverseDateMonth,
      dataSource: data.dataSource,
      spreadLink: data.spreadLink,
      dataNotes: data.dataNotes,
      logScaleAllowed: data.logScaleAllowed ?? isLogScaleAllowed(data),
    };
  }

  return state;
}

function updateData(stateTree, state, payload, prop) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));
  localStorage.setItem('saved', 'false');

  return {
    ...state,
    [prop]: payload,
    mustRender: activeDoc.mustRender,
  };
}

export { fetchChartData, updateData };
